/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";

export default function PaletteHistoryCard(props) {
  const { list, id } = props;

  return (
    <div className="history_card">
      <div className="history_card__heading_container d-grid">
        <span className="grey_text">Palette ID</span>
        <span className="text_bold">{id}</span>
        <hr />
      </div>
      <div className="history_card__statuses_container d-grid">
        {list?.map((item) => (
          <div className="status_item_container d-grid">
            <span className="grey_text">Status</span>
            <div
              className="d-flex"
              style={{ justifyContent: "space-between", color: "#023A6C" }}
            >
              <span className="text_bold">{item.Stage}</span>
              <span>{item.created_date_ISO}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

PaletteHistoryCard.propTypes = {
  list: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
};
